
export const videos = [
  {
    id: 1,
    title: 'Company Overview - Manohar International',
    description: 'Discover our journey, values, and commitment to excellence in spa, salon, and medical products.',
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 2,
    title: 'Product Showcase - Spa Equipment',
    description: 'Explore our premium range of spa equipment designed for professional wellness centers.',
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 3,
    title: 'Salon Solutions - Professional Equipment',
    description: 'See how our salon equipment transforms beauty businesses with quality and innovation.',
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  },
  {
    id: 4,
    title: 'Medical Grade Products',
    description: 'Learn about our medical-grade products that meet international safety and quality standards.',
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
  }
];
